import { render, staticRenderFns } from "./HistoryResearch.vue?vue&type=template&id=0c33e264&"
import script from "./HistoryResearch.vue?vue&type=script&lang=js&"
export * from "./HistoryResearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports